var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page basic-data" },
    [
      _c(
        "el-container",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { background: "white" }
        },
        [
          _c(
            "el-aside",
            {
              staticClass: "inner-box",
              staticStyle: {
                width: "fit-content",
                height: "calc(100vh - 210px)",
                "overflow-x": "hidden",
                "margin-top": "60px"
              }
            },
            [
              _c(
                "el-radio-group",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  on: { change: _vm.barChange },
                  model: {
                    value: _vm.currentBar,
                    callback: function($$v) {
                      _vm.currentBar = $$v
                    },
                    expression: "currentBar"
                  }
                },
                _vm._l(_vm.navigationBars, function(item, index) {
                  return _c(
                    "el-radio",
                    {
                      key: index,
                      staticStyle: { "line-height": "30px" },
                      attrs: { label: item.value }
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-main",
            { staticStyle: { padding: "0px", flex: "1" } },
            [
              _c("crm-customer-type", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "CustomerType",
                    expression: "currentBar === 'CustomerType'"
                  }
                ],
                ref: "customerType"
              }),
              _c("customer-contact-channel", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "CustomerContactChannel",
                    expression: "currentBar === 'CustomerContactChannel'"
                  }
                ],
                ref: "customerContactChannel"
              }),
              _c("customer-rating", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "CustomerRating",
                    expression: "currentBar === 'CustomerRating'"
                  }
                ],
                ref: "customerRating"
              }),
              _c("difficulty-index", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBar === "DifficultyIndex",
                    expression: "currentBar === 'DifficultyIndex'"
                  }
                ],
                ref: "difficultyIndex"
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }